<template>
    <div class="row">
        <div class="input-field col s8">
            <input type="text" name="nome" id="nome" v-model="item.nome"/>
            <label for="nome">Nome</label>
        </div>
        <div class="input-field col s2">

           <select id="pontuacao" v-model="item.pontos">
               <option v-for="(ponto,index) in this.pontos" :key="index">
                   {{ponto}}
               </option>
           </select>
           <label for="pontuacao">Pontos</label>

        </div>
        <div class="input-field col s2">
            <button class="btn waves-effect waves-light" type="button" id='btnAddItem' @click="addItem()">
                <i class="material-icons">add</i>
            </button>
        </div>

    </div>
</template>
<script>


   export default {
        name:'AvaliacaoCurriculoItemFormacaoAddItemForm',
        props:{
            pontos:{
                type:Array
            }
        },
        data(){
            return {
                item:{
                    id:0,
                    nome:'',
                    pontos:0,
                }
            }
        },
        methods:{
            resetItem(){
                this.$set(this,'item',{
                    id:0,
                    nome:'',
                    pontos:0,
                })
            },
            addItem(){
                this.$emit('add-new-item',this.item);
                this.resetItem();
            }
        },
        mounted(){
            if(global.$)
                $('.materialize-select').formSelect();


        }
    }

</script>
